// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowRotateRight } from '@ni/nimble-components/dist/esm/icons/arrow-rotate-right';
import { wrap } from '../utilities/react-wrapper';

export { type IconArrowRotateRight };
export const NimbleIconArrowRotateRight = wrap(IconArrowRotateRight);